import { SEO } from "@/components/SEO";
import { FadeIn } from "@/components/FadeIn";
import { RevealHeading } from "@/components/RevealHeading";
import { SectionLabel } from "@/components/SectionLabel";
import { images } from "@/data/images";

const values = ["Discipline", "Strategy", "Execution", "Innovation", "Integrity", "Growth"];

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO
        title="About"
        description="DULORME LABS was built around one principle: businesses grow when strategy, execution and technology work together."
        path="/about"
      />

      <section className="pt-40 pb-24 border-b border-white/10">
        <div className="container-custom">
          <SectionLabel>About DULORME LABS™</SectionLabel>
          <RevealHeading
            tag="h1"
            lines={["WE DON'T BUILD CAMPAIGNS.", "WE BUILD MOMENTUM."]}
            className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.0] tracking-tight text-white max-w-3xl"
          />
          <FadeIn delay={0.3}>
            <p className="mt-8 text-base md:text-lg text-zinc-400 max-w-xl leading-relaxed">
              DULORME LABS was created around one principle: businesses grow when strategy, execution and technology work together.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="py-28 border-b border-white/10">
        <div className="container-custom grid lg:grid-cols-2 gap-16">
          <FadeIn>
            <p className="text-xs uppercase tracking-widest text-violet-400 mb-4">Mission</p>
            <p className="font-display text-2xl md:text-3xl text-white leading-tight">
              Help ambitious businesses build stronger brands, acquire customers and create scalable digital growth systems.
            </p>
          </FadeIn>
          <FadeIn delay={0.15}>
            <p className="text-xs uppercase tracking-widest text-violet-400 mb-4">Vision</p>
            <p className="font-display text-2xl md:text-3xl text-white leading-tight">
              Build a modern growth company capable of helping businesses across industries compete, evolve and scale.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="py-28 border-b border-white/10 bg-[#0A0A0A]">
        <div className="container-custom">
          <FadeIn className="mb-14 max-w-xl">
            <SectionLabel>Our Values</SectionLabel>
            <h2 className="font-display font-bold text-3xl md:text-4xl tracking-tight text-white">What Drives Every Project</h2>
          </FadeIn>
          <div className="grid sm:grid-cols-3 lg:grid-cols-6 border-t border-l border-white/10">
            {values.map((v, i) => (
              <FadeIn key={v} delay={i * 0.05}>
                <div data-testid={`about-value-${i}`} className="border-r border-b border-white/10 p-7 h-full">
                  <span className="text-xs text-zinc-600 font-display block mb-8">{String(i + 1).padStart(2, "0")}</span>
                  <p className="font-display text-lg font-semibold text-white">{v}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <section className="py-28">
        <div className="container-custom grid lg:grid-cols-12 gap-12 items-center">
          <FadeIn className="lg:col-span-5">
            <img src={images.officeDesk} alt="Modern workspace representing focused strategic work" className="w-full aspect-[4/5] object-cover" />
          </FadeIn>
          <FadeIn delay={0.15} className="lg:col-span-7">
            <SectionLabel>The Team</SectionLabel>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
              Team profiles coming soon.
            </h2>
            <p className="text-zinc-500 leading-relaxed max-w-lg" data-testid="about-team-placeholder">
              This section is reserved for founder and team information. It will be updated as DULORME LABS shares verified details about the people behind the work.
            </p>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
